import { AppModule } from "@/store/modules/app";
import { IResult, ISignalPhaseInfo, ISignalPhaseStateInfo } from "@/types/map";
import { loadModules } from "esri-loader";
// import PhaseWebWorker from "worker-loader!@/plugin/gis-viewer/workers/phase.worker";
import { Utils } from "../../Utils";
import { checkPoints } from "../MapCenterCheck/arcgis/CheckPoints";

enum PhaseColor {
  Green,
  Yellow,
  Red,
}

export default class CrossSignalPhase {
  private view: __esri.SceneView;
  // private viewWatchHandle!: __esri.WatchHandle;
  private Point!: __esri.PointConstructor;
  private Color!: __esri.ColorConstructor;
  private Polyline!: __esri.PolylineConstructor;
  private Graphic!: __esri.GraphicConstructor;
  private geometryEngine!: __esri.geometryEngine;
  private webMercatorUtils!: __esri.webMercatorUtils;

  private crossId: string;
  private arrowLayer: __esri.GraphicsLayer;
  private labelLayer: __esri.FeatureLayer;

  private currentPhaseColor = PhaseColor.Green;
  /** 绿色相位颜色 */
  private phaseColorGreen = "#76ff03";
  /** 黄色相位颜色 */
  private phaseColorYellow = "#ffff00";
  /** 红色相位颜色 */
  private phaseColorRed = "#f44336";

  // private phaseWorker!: PhaseWebWorker;
  private phaseWebSocket!: WebSocket;
  private currentPhaseInterval: string = "";

  private PhaseIntervalColor: any = {
    "1": "#00ff00",
    "2": "#00ff00",
    "3": "#ffa500",
    "4": "#ff0000",
  };

  /** 进度条符号 */
  private progressbarSymbolGreen: __esri.Symbol = {
    type: "line-3d",
    symbolLayers: [
      {
        type: "path",
        profile: "circle",
        width: 1,
        height: 1,
        material: { color: "#1b5e20" },
        cap: "round",
      },
    ],
    // type: "simple-line",
    // color: "#1b5e20",
    // width: 10
  } as any;

  private progressbarSymbolYellow: __esri.Symbol = {
    type: "line-3d",
    symbolLayers: [
      {
        type: "path",
        profile: "circle",
        width: 1,
        material: { color: "#f57f17" },
        cap: "round",
      },
    ],
  } as any;

  private progressbarSymbolRed: __esri.Symbol = {
    type: "line-3d",
    symbolLayers: [
      {
        type: "path",
        profile: "circle",
        width: 1,
        material: { color: "#d50000" },
        cap: "round",
      },
    ],
  } as any;

  /** 路口中央的车行方向箭头 */
  private allPhaseArrowGraphics: Array<__esri.Graphic> = [];
  /** 显示倒计时动画的线 */
  private allCountdownGraphics: Array<__esri.Graphic> = [];

  private initialized = false;

  /** 默认黄闪时间 */
  private readonly defaultYellowPeriod = 3;
  /** 默认全红时间 */
  private readonly defaultRedPeriod = 2;

  private yellowPeriod = 0;
  private redPeriod = 0;
  private greenPeriod = 0;

  /** 绿灯结束的计时器 */
  private greenTimeoutHandler!: number;
  /** 黄闪结束的计时器 */
  private yellowTimeoutHandler!: number;
  /** 全红结束的计时器 */
  private redTimeoutHandler!: number;
  /** 倒计时数字计时器 */
  private countdownLabelHandler!: number;

  /** 当前相位是否已经走完 */
  private isCurrentFinished = true;
  /** 下一个相位 */
  private nextSignalPhase: ISignalPhaseInfo | undefined;

  // 倒计时动画相关
  /**
   * 倒计时动画持续时间
   * 不是相位开始时就倒计时，倒计时最多不超过20秒
   */
  private countdownAnimationDuration!: number;
  private readonly maxCountdownAnimationDuration = 20;
  private countdownAnimationTimer: Array<number> = [];

  /** 通知页面查询新相位的接口 */
  public requestNextSignalPhase!: (crossId: string) => void;
  public phaseChanged!: (crossId: string, phase: string) => void;

  constructor(params: {
    view: __esri.SceneView;
    crossId: string;
    arrowLayer: __esri.GraphicsLayer;
    labelLayer: __esri.FeatureLayer;
  }) {
    this.view = params.view;
    this.crossId = params.crossId;
    this.arrowLayer = params.arrowLayer;
    this.labelLayer = params.labelLayer;
  }

  /** 此路口人行横道线的graphic */
  private _sidewalkGraphics: Array<__esri.Graphic> = [];
  set sidewalkGraphics(values: Array<__esri.Graphic>) {
    this._sidewalkGraphics = values;
  }

  public async setSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
    if (!this.initialized) {
      await this.getGrpahics();
    }
    let showCenter = params.showCenter !== false;
    if (showCenter) {
      this.view.goTo({ target: this.allPhaseArrowGraphics });
    }

    // if (!this.infoPanel) {
    //   this.showInfoPanel();
    // }

    // 不是立即跳变并且当前相位还没走完
    // 缓冲一个相位
    // if (!params.forceJump && !this.isCurrentFinished) {
    //   this.nextSignalPhase = params;
    //   return {status: 0, message: ""};
    // }
    //this.phaseWorker = new PhaseWebWorker();
    let _this = this;
    const cross = checkPoints.find(
      (point) => point.type === "cross" && point.id === params.crossId
    );
    if (!cross) {
      return { status: 0, message: "" };
    }
    // if (cross.signalPhase) {
    //   if (cross.signalPhase.wsUrl) {
    //     let wsUrl = cross.signalPhase.wsUrl;
    //     this.phaseWebSocket = new WebSocket(wsUrl);
    //     this.phaseWebSocket.onopen = () => {
    //       console.log("phase connection opened!");
    //     };
    //     this.phaseWebSocket.onclose = () => {
    //       console.log("phase connection closed!");
    //     };
    //     this.phaseWebSocket.onmessage = (event: MessageEvent) => {
    //       let data = JSON.parse(event.data);
    //       _this.startSignalPhase(data);
    //     };
    //   } else {
    //     let total = 30;
    //     cross.signalPhase.phases?.forEach((phase) => {
    //       if (phase.phase === cross.signalPhase.currentPhase) {
    //         total = phase.total;
    //       }
    //     });
    //     let currentPhase = this.getCurrentPhase();
    //     if (currentPhase) {
    //       if (this.phaseChanged && currentPhase.phase) {
    //         this.phaseChanged(params.crossId, currentPhase.phase);
    //       }

    //       this.startPhase({
    //         phase: currentPhase
    //           ? currentPhase.phase
    //           : cross.signalPhase.currentPhase || "A",
    //         totalPeriod: currentPhase
    //           ? currentPhase.total
    //           : cross.signalPhase.currentPeriod || total,
    //         crossId: params.crossId,
    //       });
    //     }
    //   }
    // } else {
    //   this.startPhase({
    //     phase: params.phase || "A",
    //     totalPeriod: params.totalPeriod || 30,
    //     crossId: params.crossId,
    //   });
    // }

    return { status: 0, message: "" };
  }
  private getCurrentPhase(): { phase: string; total: number } | undefined {
    const sumoTime = AppModule.sumoStartTime;
    if (sumoTime == 0 || sumoTime == null) {
      //console.log("获取当前相位失败");
      return undefined;
    }
    const startTime = new Date("2021/1/21 8:58:25").valueOf();
    let subsecond = Math.floor((sumoTime - startTime) / 1000);
    let phaseTime = subsecond % 160;
    let phase = "A";
    let total = 0;
    if (phaseTime < 60) {
      phase = "A";
      total = 60 - phaseTime;
    } else if (phaseTime < 120) {
      phase = "B";
      total = 120 - phaseTime;
    } else if (phaseTime < 160) {
      phase = "C";
      total = 160 - phaseTime;
    }
    console.log(
      "当前时间:" + new Date(AppModule.sumoStartTime).toLocaleString(),
      "当前相位:" + phase,
      "剩余时间:" + total
    );
    return { phase: phase, total: total };
  }

  private nextPhase(params: ISignalPhaseInfo) {
    // const cross = checkPoints.find(
    //   (point) => point.type === "cross" && point.id === params.crossId
    // );
    // if (cross?.signalPhase) {
    //   let phase = "";
    //   let total = 30;
    //   let phases = cross.signalPhase.phases || [];
    //   for (let i = 0; i < phases.length; i++) {
    //     if (phases[i].phase === params.phase) {
    //       phase = phases[(i + 1) % phases.length].phase;
    //       total = phases[(i + 1) % phases.length].total;
    //       break;
    //     }
    //   }
    //   if (this.phaseChanged && phase) {
    //     this.phaseChanged(params.crossId, phase);
    //   }
    //   this.startPhase({
    //     phase: phase,
    //     totalPeriod: total,
    //     crossId: params.crossId,
    //   });
    // }
  }
  private async stopAllTimers(phase?: string) {
    if (this.greenTimeoutHandler) {
      clearTimeout(this.greenTimeoutHandler);
    }
    if (this.yellowTimeoutHandler) {
      clearTimeout(this.yellowTimeoutHandler);
    }
    if (this.redTimeoutHandler) {
      clearTimeout(this.redTimeoutHandler);
    }
    if (this.countdownLabelHandler) {
      clearInterval(this.countdownLabelHandler);
      await this.deleteCountdownLabel();
    }
    //当绿闪的时候,不删除进度条
    if (phase !== "1") {
      if (this.countdownAnimationTimer.length > 0) {
        for (let timer of this.countdownAnimationTimer) {
          cancelAnimationFrame(timer);
        }
        this.countdownAnimationTimer = [];
      }
    }
  }

  public stopSignalPhase() {
    this.stopAllTimers();
    if (this.phaseWebSocket) {
      this.phaseWebSocket.close();
    }
    this.nextSignalPhase = undefined;
    this.isCurrentFinished = true;

    const removeGraphics: Array<__esri.Graphic> = [];
    // const addGraphics: Array<__esri.Graphic> = [];
    this.arrowLayer.graphics.forEach((graphic) => {
      if (graphic.attributes["CROSSID"] === this.crossId) {
        if (graphic.attributes["type"] === "sidewalk") {
          graphic.symbol = this.getArrowSymbol("white");
        } else {
          removeGraphics.push(graphic);
        }
      }
    });
    this.arrowLayer.removeMany(removeGraphics);
    // this.arrowLayer.addMany(addGraphics);
    this.labelLayer.labelsVisible = false;
    this.currentPhaseInterval = "";
  }

  /***如果没有websocket,按设定的相位,****/
  private async startPhase(params: ISignalPhaseInfo) {
    this.isCurrentFinished = false;

    await this.stopAllTimers();

    // 删除已添加的箭头和人行横道线
    const removeGraphics = this.arrowLayer.graphics
      .filter((graphic) => graphic.attributes["CROSSID"] === this.crossId)
      .toArray();
    this.arrowLayer.removeMany(removeGraphics);

    const { phase, totalPeriod } = params;

    // 当前相位的所有箭头
    const phaseArrowGraphics = this.allPhaseArrowGraphics.filter((graphic) =>
      graphic.attributes["PHASE"].includes(phase)
    );

    // 倒计时条
    const phaseProgressGraphics = this.allCountdownGraphics.filter((graphic) =>
      graphic.attributes["PHASE"].includes(phase)
    );
    await this.showCountdownLabel(phaseProgressGraphics, totalPeriod);

    // 生成当前相位的红黄绿箭头graphic
    const greenPhaseGraphics: Array<__esri.Graphic> = [],
      yellowPhaseGraphics: Array<__esri.Graphic> = [],
      redPhaseGraphics: Array<__esri.Graphic> = [];

    phaseArrowGraphics.forEach((graphic) => {
      const greenArrow = this.getArrowGraphic(graphic);
      greenArrow.symbol = this.getArrowSymbol(this.phaseColorGreen);
      greenArrow.attributes["type"] = "arrow";
      greenPhaseGraphics.push(greenArrow);

      const yellowArrow = this.getArrowGraphic(graphic);
      yellowArrow.symbol = this.getArrowSymbol(this.phaseColorYellow);
      yellowArrow.attributes["type"] = "arrow";
      yellowPhaseGraphics.push(yellowArrow);

      const redArrow = this.getArrowGraphic(graphic);
      redArrow.symbol = this.getArrowSymbol(this.phaseColorRed);
      redArrow.attributes["type"] = "arrow";
      redPhaseGraphics.push(redArrow);
    });

    // 生成人行横道线graphic
    // 当前相位的生成红黄绿色graphic，非当前相位的生成白色graphic
    this._sidewalkGraphics.forEach((graphic) => {
      // 绿灯时的人行道
      const greenSidewalk = graphic.clone();
      greenSidewalk.attributes["type"] = "sidewalk";
      if (greenSidewalk.attributes["PHASE"] === phase) {
        greenSidewalk.symbol = this.getArrowSymbol(this.phaseColorGreen);
        greenSidewalk.attributes["color"] = "green";
      } else {
        greenSidewalk.symbol = this.getArrowSymbol([255, 255, 255, 0.8]);
        greenSidewalk.attributes["color"] = "white";
      }
      greenPhaseGraphics.push(greenSidewalk);

      // 黄闪时的人行道
      const yellowSidewalk = graphic.clone();
      yellowSidewalk.attributes["type"] = "sidewalk";
      if (yellowSidewalk.attributes["PHASE"] === phase) {
        yellowSidewalk.symbol = this.getArrowSymbol(this.phaseColorYellow);
        yellowSidewalk.attributes["color"] = "yellow";
      } else {
        yellowSidewalk.symbol = this.getArrowSymbol([255, 255, 255, 0.8]);
        yellowSidewalk.attributes["color"] = "white";
      }
      yellowPhaseGraphics.push(yellowSidewalk);

      // 全红时的人行道
      const redSidewalk = graphic.clone();
      redSidewalk.attributes["type"] = "sidewalk";
      if (redSidewalk.attributes["PHASE"] === phase) {
        redSidewalk.symbol = this.getArrowSymbol(this.phaseColorRed);
        redSidewalk.attributes["color"] = "red";
      } else {
        redSidewalk.symbol = this.getArrowSymbol([255, 255, 255, 0.8]);
        redSidewalk.attributes["color"] = "white";
      }
      redPhaseGraphics.push(redSidewalk);
    });

    // 进入绿灯
    this.arrowLayer.addMany(greenPhaseGraphics);
    this.currentPhaseColor = PhaseColor.Green;

    // totalPeriod = 0，相位锁定，不倒计时
    if (totalPeriod !== 0) {
      // 计算红黄绿持续时间
      this.yellowPeriod = params.yellowPeriod || this.defaultYellowPeriod;
      this.redPeriod = params.redPeriod || this.defaultRedPeriod;
      this.greenPeriod = totalPeriod - this.yellowPeriod - this.redPeriod;

      this.countdownAnimationDuration = Math.min(
        this.maxCountdownAnimationDuration,
        totalPeriod
      );

      // 显示倒计时数字
      let currentCountdown = totalPeriod;
      let phaseColor = "1";
      this.countdownLabelHandler = setInterval(async () => {
        if (currentCountdown === 0) {
          clearInterval(this.countdownLabelHandler);
        }
        await this.updateCountdownLabel(currentCountdown, phaseColor);
        currentCountdown--;
      }, 1000);

      // 倒计时进度条开始时间
      const countdownStartTime = totalPeriod - this.countdownAnimationDuration;
      // 显示倒计时进度条
      phaseProgressGraphics.forEach((graphic) => {
        setTimeout(() => {
          // 进度条背景
          const backgroundGraphic = graphic.clone();
          backgroundGraphic.symbol = {
            type: "line-3d",
            symbolLayers: [
              {
                type: "path",
                profile: "quad",
                width: 1.2,
                height: 0.5,
                material: { color: [255, 255, 255, 0.8] },
                cap: "round",
                profileRotation: "heading",
              },
            ],
          } as any;
          // 进度条本体
          this.arrowLayer.add(backgroundGraphic);
          this.startCountdownAnimation(graphic.geometry as __esri.Polyline);
        }, countdownStartTime * 1000);
      });

      // 进入黄闪
      this.greenTimeoutHandler = setTimeout(() => {
        // 请求新相位
        phaseColor = "3";
        if (this.requestNextSignalPhase) {
          this.requestNextSignalPhase(this.crossId);
        }

        this.arrowLayer.removeMany(greenPhaseGraphics);
        this.arrowLayer.addMany(yellowPhaseGraphics);
        this.currentPhaseColor = PhaseColor.Yellow;
        // this.infoPanel.$props.color = "#ffff00";

        const yellowFlashHandler = setInterval(() => {
          yellowPhaseGraphics.forEach((graphic) => {
            // 带颜色的箭头和人行横道先闪烁
            if (graphic.attributes["color"] !== "white")
              graphic.visible = !graphic.visible;
          });
        }, 500);

        // 进入全红
        this.yellowTimeoutHandler = setTimeout(() => {
          phaseColor = "4";
          clearInterval(yellowFlashHandler);

          this.arrowLayer.removeMany(yellowPhaseGraphics);
          this.arrowLayer.addMany(redPhaseGraphics);
          this.currentPhaseColor = PhaseColor.Red;
          // this.infoPanel.$props.color = "#f44336";

          // 相位走完
          this.redTimeoutHandler = setTimeout(() => {
            this.isCurrentFinished = true;
            this.nextPhase(params);
            // if (this.nextSignalPhase) {
            //   this.startPhase(this.nextSignalPhase);
            //   this.nextSignalPhase = undefined;
            // }
          }, this.redPeriod * 1000);
        }, this.yellowPeriod * 1000);
      }, this.greenPeriod * 1000);
    }
  }
  /*******/
  private async startSignalPhase(params: ISignalPhaseStateInfo) {
    const {
      phaseId,
      currentPhaseInterval, //当前相位状态
      lockedPhaseId,
      phaseElapsedTime, //运行时间,
      greenTime, //绿灯时间
      greenFlash, //黄闪事件
      yellowTime, //黄灯时间
    } = params;
    const phase = Utils.getCharLetter(phaseId);
    if (lockedPhaseId !== "") {
      return;
    }
    let greenFlashHandler, yellowFlashHandler;
    let countdownStartTime = this.getPhaseCountTime(params); //等到每个相位状态的剩余时间
    this.countdownAnimationDuration = Math.min(
      this.maxCountdownAnimationDuration,
      countdownStartTime
    );
    // 显示倒计时数字
    let currentCountdown = countdownStartTime;
    this.updateCountdownLabel(currentCountdown, currentPhaseInterval);
    //当前相位状态不变.
    if (this.currentPhaseInterval === currentPhaseInterval) {
      return;
    }
    this.isCurrentFinished = false;
    await this.stopAllTimers(currentPhaseInterval);

    // 当前相位的所有箭头
    const phaseArrowGraphics = this.allPhaseArrowGraphics.filter((graphic) =>
      graphic.attributes["PHASE"].includes(phase)
    );

    // 倒计时条
    const phaseProgressGraphics = this.allCountdownGraphics.filter((graphic) =>
      graphic.attributes["PHASE"].includes(phase)
    );

    await this.showCountdownLabel(phaseProgressGraphics, countdownStartTime);
    const greenPhaseGraphics: Array<__esri.Graphic> = [],
      yellowPhaseGraphics: Array<__esri.Graphic> = [],
      redPhaseGraphics: Array<__esri.Graphic> = [];
    // 删除已添加的箭头和人行横道线
    const removeGraphics = this.arrowLayer.graphics
      .filter((graphic) => graphic.attributes["CROSSID"] === this.crossId)
      .toArray();
    this.arrowLayer.removeMany(removeGraphics);

    // 生成当前相位的红黄绿箭头graphic
    phaseArrowGraphics.forEach((graphic) => {
      const greenArrow = this.getArrowGraphic(graphic);
      greenArrow.symbol = this.getArrowSymbol(this.phaseColorGreen);
      greenArrow.attributes["type"] = "arrow";
      greenPhaseGraphics.push(greenArrow);

      const yellowArrow = this.getArrowGraphic(graphic);
      yellowArrow.symbol = this.getArrowSymbol(this.phaseColorYellow);
      yellowArrow.attributes["type"] = "arrow";
      yellowPhaseGraphics.push(yellowArrow);

      const redArrow = this.getArrowGraphic(graphic);
      redArrow.symbol = this.getArrowSymbol(this.phaseColorRed);
      redArrow.attributes["type"] = "arrow";
      redPhaseGraphics.push(redArrow);
    });
    // 生成人行横道线graphic
    // 当前相位的生成红黄绿色graphic，非当前相位的生成白色graphic
    this._sidewalkGraphics.forEach((graphic) => {
      // 绿灯时的人行道
      const greenSidewalk = graphic.clone();
      greenSidewalk.attributes["type"] = "sidewalk";
      if (greenSidewalk.attributes["PHASE"] === phase) {
        greenSidewalk.symbol = this.getArrowSymbol(this.phaseColorGreen);
        greenSidewalk.attributes["color"] = "green";
      } else {
        greenSidewalk.symbol = this.getArrowSymbol([255, 255, 255, 0.8]);
        greenSidewalk.attributes["color"] = "white";
      }
      greenPhaseGraphics.push(greenSidewalk);

      // 黄闪时的人行道
      const yellowSidewalk = graphic.clone();
      yellowSidewalk.attributes["type"] = "sidewalk";
      if (yellowSidewalk.attributes["PHASE"] === phase) {
        yellowSidewalk.symbol = this.getArrowSymbol(this.phaseColorYellow);
        yellowSidewalk.attributes["color"] = "yellow";
      } else {
        yellowSidewalk.symbol = this.getArrowSymbol([255, 255, 255, 0.8]);
        yellowSidewalk.attributes["color"] = "white";
      }
      yellowPhaseGraphics.push(yellowSidewalk);

      // 全红时的人行道
      const redSidewalk = graphic.clone();
      redSidewalk.attributes["type"] = "sidewalk";
      if (redSidewalk.attributes["PHASE"] === phase) {
        redSidewalk.symbol = this.getArrowSymbol(this.phaseColorRed);
        redSidewalk.attributes["color"] = "red";
      } else {
        redSidewalk.symbol = this.getArrowSymbol([255, 255, 255, 0.8]);
        redSidewalk.attributes["color"] = "white";
      }
      redPhaseGraphics.push(redSidewalk);
    });
    switch (currentPhaseInterval) {
      case "1": //绿灯
        //进度条
        this.labelLayer.labelsVisible = true;
        this.arrowLayer.addMany(greenPhaseGraphics);
        this.currentPhaseColor = PhaseColor.Green;
        let startCountTime =
          countdownStartTime - this.countdownAnimationDuration;
        phaseProgressGraphics.forEach((graphic) => {
          setTimeout(() => {
            // 进度条背景
            const backgroundGraphic = graphic.clone();
            backgroundGraphic.symbol = {
              type: "line-3d",
              symbolLayers: [
                {
                  type: "path",
                  profile: "quad",
                  width: 1.2,
                  height: 4.5,
                  material: { color: [255, 255, 255, 0.8] },
                  cap: "round",
                  profileRotation: "heading",
                },
              ],
            } as any;
            // 进度条本体
            //this.arrowLayer.add(backgroundGraphic);
            this.startCountdownAnimation(graphic.geometry as __esri.Polyline);
          }, startCountTime * 1000);
        });
        break;
      case "2": //绿闪
        this.labelLayer.labelsVisible = true;
        this.arrowLayer.addMany(greenPhaseGraphics);
        greenFlashHandler = setInterval(() => {
          greenPhaseGraphics.forEach((graphic) => {
            // 带颜色的箭头和人行横道先闪烁
            if (graphic.attributes["color"] !== "white") {
              graphic.visible = !graphic.visible;
            }
          });
        }, 500);
        break;
      case "3": //黄灯
        this.labelLayer.labelsVisible = false;
        clearInterval(greenFlashHandler);
        this.arrowLayer.removeMany(greenPhaseGraphics);
        this.arrowLayer.addMany(yellowPhaseGraphics);
        this.currentPhaseColor = PhaseColor.Yellow;
        // this.infoPanel.$props.color = "#ffff00";

        yellowFlashHandler = setInterval(() => {
          yellowPhaseGraphics.forEach((graphic) => {
            // 带颜色的箭头和人行横道先闪烁
            if (graphic.attributes["color"] !== "white")
              graphic.visible = !graphic.visible;
          });
        }, 500);
        break;
      case "4": //红灯
        this.labelLayer.labelsVisible = false;
        clearInterval(yellowFlashHandler);
        this.arrowLayer.removeMany(yellowPhaseGraphics);
        this.arrowLayer.addMany(redPhaseGraphics);
        this.currentPhaseColor = PhaseColor.Red;
        break;
      case "5": //下一个相位,全红
        this.isCurrentFinished = true;
        if (this.nextSignalPhase) {
          //this.startPhase(this.nextSignalPhase);
          //this.nextSignalPhase = undefined;
        }
        break;
    }
    this.currentPhaseInterval = currentPhaseInterval;
  }
  private getPhaseCountTime(params: ISignalPhaseStateInfo) {
    let countTime = 0;
    const {
      currentPhaseInterval, //当前相位状态
      phaseElapsedTime, //运行时间,
      greenTime, //绿灯时间
      greenFlash, //黄闪事件
      yellowTime, //黄灯时间
    } = params;
    if (currentPhaseInterval == "1") {
      //绿灯
      countTime =
        Number(greenTime) - Number(phaseElapsedTime) + Number(greenFlash);
    } else if (currentPhaseInterval == "2") {
      countTime =
        Number(greenFlash) - (Number(phaseElapsedTime) - Number(greenTime));
    } else if (currentPhaseInterval == "3") {
      countTime =
        Number(yellowTime) -
        (Number(phaseElapsedTime) - Number(greenTime) - Number(greenFlash)) +
        1;
    } else {
      countTime = 0;
    }
    return countTime;
  }
  private async getGrpahics() {
    type MapModules = [
      typeof import("esri/layers/FeatureLayer"),
      typeof import("esri/geometry/Point"),
      typeof import("esri/geometry/Polyline"),
      typeof import("esri/geometry/geometryEngine"),
      typeof import("esri/geometry/support/webMercatorUtils"),
      typeof import("esri/Color"),
      typeof import("esri/Graphic")
    ];
    const [
      FeatureLayer,
      Point,
      Polyline,
      geometryEngine,
      webMercatorUtils,
      Color,
      Graphic,
    ] = await (loadModules([
      "esri/layers/FeatureLayer",
      "esri/geometry/Point",
      "esri/geometry/Polyline",
      "esri/geometry/geometryEngine",
      "esri/geometry/support/webMercatorUtils",
      "esri/Color",
      "esri/Graphic",
    ]) as Promise<MapModules>);

    this.Point = Point;
    this.Color = Color;
    this.Polyline = Polyline;
    this.Graphic = Graphic;
    this.geometryEngine = geometryEngine;
    this.webMercatorUtils = webMercatorUtils;

    // 相位箭头
    const phaseArrowLayer = new FeatureLayer({
      url: `http://${AppModule.appConfig.gisServer}/arcgis/rest/services/Unicron/ShangHai_Road/MapServer/4`,
    });
    let query = phaseArrowLayer.createQuery();
    query.where = `CROSSID = '${this.crossId}'`;
    query.outFields = ["*"];
    let result = await phaseArrowLayer.queryFeatures(query);
    this.allPhaseArrowGraphics = result.features;
    // 相位进度条
    const phaseProgressLayer = new FeatureLayer({
      url: `http://${AppModule.appConfig.gisServer}/arcgis/rest/services/Unicron/ShangHai_Road/MapServer/6`,
    });
    query = phaseProgressLayer.createQuery();
    query.where = `CROSSID = '${this.crossId}'`;
    query.outFields = ["*"];
    result = await phaseProgressLayer.queryFeatures(query);
    this.allCountdownGraphics = result.features;
    this.initialized = true;
  }

  private getArrowSymbol(
    color: string | number[] | number,
    height: number = 0.1
  ): __esri.Symbol {
    const extrudeColor = new this.Color(color);
    extrudeColor.a = 0.9;
    const edgeColor = new this.Color(color);
    // return {
    //   type: "polygon-3d",
    //   symbolLayers: [
    //     {
    //       type: "extrude",
    //       castShadows: false,
    //       size: height,
    //       material: {color: extrudeColor},
    //       edges: {
    //         type: "solid",
    //         color: edgeColor
    //       }
    //     }
    //   ]
    // } as any;
    return {
      type: "simple-fill",
      color: extrudeColor,
      outline: {
        color: extrudeColor,
      },
    } as any;
  }

  /** 在原有的箭头多边形上加上高度，浮在空中 */
  private getArrowGraphic(graphic: __esri.Graphic): __esri.Graphic {
    const floatGraphic = graphic.clone();
    // const polygon = floatGraphic.geometry as __esri.Polygon;
    // polygon.hasZ = true;
    // polygon.rings.forEach((ring) => {
    //   ring.forEach((point) => {
    //     point.push(this.floatArrowHeight);
    //   });
    // });
    return floatGraphic;
  }

  private async showCountdownLabel(
    graphics: Array<__esri.Graphic>,
    countdown: number
  ) {
    const addGraphics = graphics.map((graphic) => {
      const line = graphic.geometry as __esri.Polyline;
      const center = line.extent.center;
      const addGraphic = new this.Graphic({
        geometry: center,
        attributes: {
          CROSSID: this.crossId,
          countdown,
        },
      });
      return addGraphic;
    });
    const edits = { addFeatures: addGraphics };
    await this.labelLayer.applyEdits(edits);
  }

  private async updateCountdownLabel(countdown: number, phaseInterval: string) {
    const graphics = (await this.labelLayer.queryFeatures()).features;
    graphics.forEach((graphic) => {
      graphic.attributes["countdown"] = countdown;
    });
    const edits = { updateFeatures: graphics };
    this.labelLayer.labelingInfo = [
      {
        labelPlacement: "above-center",
        labelExpressionInfo: {
          expression: "$feature.countdown",
        },
        symbol: {
          type: "label-3d",
          symbolLayers: [
            {
              type: "text",
              material: {
                color: this.PhaseIntervalColor[phaseInterval] || "white",
              },
              halo: {
                color: [255, 255, 255, 0.6],
                size: 1,
              },
              size: 20,
            },
          ],
          verticalOffset: {
            screenLength: 5,
            maxWorldLength: 5,
            minWorldLength: 1,
          },
          // callout: {
          //   type: "line",
          //   size: 1,
          //   color: [0, 0, 0],
          //   border: {
          //     color: [255, 255, 255, 0.7]
          //   }
          // }
        },
      } as any,
    ];
    await this.labelLayer.applyEdits(edits);
  }

  private async deleteCountdownLabel() {
    const graphics = (await this.labelLayer.queryFeatures()).features;
    const edits = { deleteFeatures: graphics };
    await this.labelLayer.applyEdits(edits);
  }

  private startCountdownAnimation(originLine: __esri.Polyline) {
    const line: __esri.Polyline = (!originLine.spatialReference.isWebMercator
      ? this.webMercatorUtils.geographicToWebMercator(originLine)
      : originLine) as __esri.Polyline;
    let currentHopGraphic = new this.Graphic({
      geometry: line,
      attributes: {
        CROSSID: this.crossId,
      },
    });

    /** 每个hop的动画需要多少毫秒 */
    const targetHopDuration = 1000 * this.countdownAnimationDuration;
    /** 整段动画已经画了多少帧 */
    let frameCount = 0;
    /** 整段动画在帧动画上花费时间 */
    let totalFrameTime = 0;
    /** 每帧平均持续时间（毫秒） */
    let averageFrameDuration = 1000 / 60;
    /** 每帧之间的时间间隔（毫秒） */
    let averageFramePeriod = averageFrameDuration;
    /** 整段动画开始时间戳 */
    let overallStartTime: number | undefined;
    /** 本段动画预计结束时间戳 */
    let hopEndTargetTime: number;

    this.countdownAnimationTimer.push(
      requestAnimationFrame(() => {
        updateAnimation();
      })
    );

    const updateAnimation = () => {
      const frameStartTime = performance.now();
      if (overallStartTime) {
        averageFramePeriod = (frameStartTime - overallStartTime) / frameCount;
        averageFrameDuration = totalFrameTime / frameCount;
      } else {
        overallStartTime = frameStartTime;
        hopEndTargetTime = overallStartTime + targetHopDuration;
      }

      /** 本段动画剩余时间（毫秒） */
      const hopTimeRemaining = hopEndTargetTime - frameStartTime;
      /** 本段动画剩余帧数 */
      const frameRemainingInHop = hopTimeRemaining / averageFramePeriod;
      const forceCompleteOnThisFrame = frameRemainingInHop < 0.5;

      const uncorrectedHopProgress = 1 - hopTimeRemaining / targetHopDuration;
      /** 本段动画在当前帧的完成进度百分比 */
      const hopProgress = forceCompleteOnThisFrame
        ? 1
        : Math.min(1, uncorrectedHopProgress);
      // 倒计时表现为缩短动画
      const subLine = this.getSubLine(line, 1 - hopProgress);

      // 更新图层。需要先remove再add，只更新graphic.geometry不会刷新
      this.arrowLayer.remove(currentHopGraphic);

      currentHopGraphic = new this.Graphic({
        geometry: subLine,
        symbol:
          this.currentPhaseColor === PhaseColor.Green
            ? this.progressbarSymbolGreen
            : this.currentPhaseColor === PhaseColor.Yellow
            ? this.progressbarSymbolYellow
            : this.progressbarSymbolRed,
        attributes: {
          CROSSID: this.crossId,
        },
      });
      this.arrowLayer.add(currentHopGraphic);

      const frameEndTime = performance.now();
      totalFrameTime += frameEndTime - frameStartTime;
      frameCount++;

      // 画完一个hop
      if (hopProgress < 1) {
        this.countdownAnimationTimer.push(
          requestAnimationFrame(() => {
            updateAnimation();
          })
        );
      }
    };
  }

  private getSubLine(
    sourceLine: __esri.Polyline,
    portionToReturn: number
  ): __esri.Polyline {
    /** 本段hop总长度 */
    const lineLength = this.geometryEngine.planarLength(sourceLine, "meters");
    /** 要截取的长度 */
    const targetLength = lineLength * portionToReturn;
    /** 已遍历的长度 */
    let cumulativeLength = 0;
    const targetPath = [];
    let vertexIndex;

    for (let path of sourceLine.paths) {
      let tailVertex: Array<number> = [];

      for (vertexIndex = 0; vertexIndex < path.length - 1; vertexIndex++) {
        /** 当前节点到下一个节点之间的长度 */
        const vertexGap = Math.sqrt(
          Math.pow(path[vertexIndex + 1][0] - path[vertexIndex][0], 2) +
            Math.pow(path[vertexIndex + 1][1] - path[vertexIndex][1], 2)
        );
        cumulativeLength += vertexGap;

        if (cumulativeLength === targetLength) {
          // 终点正好在节点上
          tailVertex = path[vertexIndex + 1];
          break;
        } else if (cumulativeLength > targetLength) {
          // 终点在两个节点之间
          /** 起点到当前点之间的长度 */
          const lengthToThisVertex = cumulativeLength - vertexGap;
          /** 在当前节点和下一个节点之间要截取的百分比 */
          const targetGapRatio =
            (targetLength - lengthToThisVertex) / vertexGap;
          const thisVertex = path[vertexIndex];
          const nextVertex = path[vertexIndex + 1];
          tailVertex = [
            thisVertex[0] + (nextVertex[0] - thisVertex[0]) * targetGapRatio,
            thisVertex[1] + (nextVertex[1] - thisVertex[1]) * targetGapRatio,
          ];
          break;
        }
      }

      if (vertexIndex < path.length - 1) {
        // 已经找到终点
        const partialPath = path.slice(0, vertexIndex + 1);
        partialPath.push(tailVertex);
        targetPath.push(partialPath);
        break;
      } else {
        targetPath.push(path);
      }
    }

    return new this.Polyline({
      paths: targetPath,
      spatialReference: sourceLine.spatialReference,
    });
  }
}
